import { render, staticRenderFns } from "./LogoGym.vue?vue&type=template&id=5314047f&"
import script from "./LogoGym.vue?vue&type=script&lang=js&"
export * from "./LogoGym.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports